const PERMISSION_KEY= "core:referral_registration";
const PAGE_URL = {
    REFERRAL_REGISTRATION_PAGE: "/admin/core/referral-registration"
}

export {PERMISSION_KEY, PAGE_URL}

